type OfferCard = { status: string; truncated?: boolean };

export function offerExportAvailability(card: OfferCard | undefined): { enabled: boolean; reason?: string } {
  if (card?.truncated) {
    return {
      enabled: false,
      reason: 'Only part of the offer data was returned. CSV export requires the complete result.',
    };
  }
  if (card?.status === 'ready' || card?.status === 'empty') return { enabled: true };
  return { enabled: false, reason: 'Offer data is unavailable. CSV export requires the complete result.' };
}

/** Display missing channel names without changing the source identity or aggregation. */
export function trafficChannelLabel(channel: string): string {
  return channel.trim() ? channel : 'Not recorded';
}
